import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  CircularProgress,
  Box,
  ListItemButton,
} from "@mui/material";
import * as services from "../../../services/customer";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";

const CustomerListModal = ({ open, onClose, groupId }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      let res = await services.getCustomers();
      setCustomers(res.data.data);
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการโหลดรายชื่อซัพพลายเออร์:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCustomer = async (customerId) => {
    try {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        title: "ยืนยันที่จะเพิ่มซัพพลายเออร์?",
        text: "คุณมั่นใจหรือไหมที่จะทำสิ่งนี้!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true,
      }).then(async (result) => {
        let payload = {
          customerId: customerId,
          groupId: Number(groupId),
        };
        if (result.isConfirmed) {
          await services.addCustomerToGroup(payload);
          toast.success("เพิ่มซัพพลายเออร์เข้ากลุ่มเรียบร้อยแล้ว");
          onClose();
        }
      });
    } catch (error) {
      console.error("เพิ่มซัพพลายเออร์เข้ากลุ่มล้มเหลว:", error);
      toast.error("เพิ่มซัพพลายเออร์เข้ากลุ่มล้มเหลว");
    }
  };

  useEffect(() => {
    if (open) fetchCustomers();
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>เลือกซัพพลายเออร์เพื่อเพิ่มเข้ากลุ่ม</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <List>
            {customers.map((customer) => (
              <React.Fragment key={customer.id}>
                <ListItemButton
                  onClick={() => handleSelectCustomer(customer.id)}
                >
                  <ListItemText
                    primary={
                      <Typography fontWeight="bold">{customer.name}</Typography>
                    }
                    secondary={
                      <>
                        <Typography variant="body2" color="text.secondary">
                          โทร: {customer.phone}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          อีเมล: {customer.email}
                        </Typography>
                      </>
                    }
                  />
                </ListItemButton>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ปิด</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerListModal;
